// Importa Feather Icons
import feather from "feather-icons";

// Importa MixItUp e il modulo multifiltro
import mixitup from 'mixitup';
import mixitupMultifilter from 'mixitup-multifilter';

mixitup.use(mixitupMultifilter);

var filterArray = [];
var mixer = null;
var toggleFiltersButton = document.querySelector('.js-toggle-filters');
var filtersContainer = document.getElementById('category-filters');
var filterSubmitButton = document.querySelector('.js-filter-element-btn');
var filterCheckboxes = document.querySelectorAll('.js-filter-input')
var filtersGroups = document.querySelectorAll('[data-filter-group]');
var removeFilter = document.querySelector('.remove-filters-container');
var removeFiltersMobile = document.querySelector('.mobile-remove-filters-container');
var activeFiltersDesktop = document.querySelector('.active-filters-container');
var removeAllFiltersButton = document.querySelectorAll('.js-remove-all-filters');
var closeFiltersButton = document.querySelector('.js-close-filters');
const familyCards = document.querySelectorAll('.family-card');
const separatorBlocks = document.querySelectorAll('.separator-block');

function initMixer() {

    if (document.querySelector('.category-products-mixer') === null) {
        return;
    }

    // console.log('Inizializzazione MixItUp per i prodotti di categoria');

    const containerEl = document.querySelector('.category-products-mixer');

    mixer = mixitup(containerEl, {
        multifilter: {
            enable: true,
            parseOn: 'submit',
            logicBetweenGroups: 'and',
            logicWithinGroup: 'or'
        },
        selectors: {
            target: '.category-product-item',
            control: '.js-filter-input'
        },
        animation: {
            duration: 300
        },
        debug: { enable: true }
    });
}

function showFamilyCards() {
    familyCards.forEach(card => {
        card.parentElement.style.display = 'block';
    });
}

function showSeparatorBlocks() {
    separatorBlocks.forEach(block => {
        block.style.display = 'block';
    });
}

function hideFamilyCards() {
    familyCards.forEach(card => {
        card.parentElement.style.display = 'none';
    });
}

function hideSeparatorBlocks() {
    separatorBlocks.forEach(block => {
        block.style.display = 'none';
    });
}

function showDesktopElements() {
    removeFilter.style.display = 'block';
    activeFiltersDesktop.style.display = 'flex';

    removeFilter.classList.add('active');
    activeFiltersDesktop.classList.add('active');
}

function hideDesktopElements() {
    removeFilter.style.display = 'none';
    activeFiltersDesktop.style.display = 'none';
    removeFilter.classList.remove('active');
    activeFiltersDesktop.classList.remove('active');
}

function resetDesktopElements() {

    activeFiltersDesktop.innerHTML = '';

    removeFilter.style.display = 'none';
    activeFiltersDesktop.style.display = 'none';

    removeFilter.classList.remove('active');
    activeFiltersDesktop.classList.remove('active');
}

function getActiveFiltersCount() {
    let count = 0;
    filterCheckboxes.forEach(box => {
        if (box.checked) {
            count += 1;
        }
    });

    return count;
}

function updateMobileActiveFiltersCount() {
    const count = getActiveFiltersCount();
    const existingCountElem = document.querySelector('.mobile-active-filters-count');

    if (count > 0) {
        if (existingCountElem) {
            existingCountElem.innerHTML = `(${count})`;
        } else {
            toggleFiltersButton.innerHTML += `<span class="mobile-active-filters-count">(${count})</span>`;
        }
    } else {
        if (existingCountElem) {
            existingCountElem.remove();
        }
    }
}

function getActiveFilters() {
    let activeFiltersList = [];
    filterCheckboxes.forEach(box => {
        if (box.checked) {
            const label = box.nextElementSibling ? box.nextElementSibling.textContent.trim() : box.value;
            activeFiltersList.push(label);
        }
    });

    return activeFiltersList;
}

function createActiveFiltersHTML(activeFiltersList) {
    // Creo html per i filtri attivi
    let activeFiltersHTML = '';
    activeFiltersList.forEach(filterLabel => {
        activeFiltersHTML += `<a href="#" class="btn btn-secondary active-filter-item with-icon"><i data-feather="x"></i>${filterLabel}</a> `;
    });

    activeFiltersDesktop.innerHTML = activeFiltersHTML;

    feather.replace({ "stroke-width": 1 });

    document.querySelectorAll('.active-filter-item').forEach(activeFilterBtn => {
        activeFilterBtn.addEventListener('click', function (e) {
            e.preventDefault();
            // Removi il filtro associato
            const filterLabel = this.textContent.trim();
            filterCheckboxes.forEach(box => {
                const label = box.nextElementSibling ? box.nextElementSibling.textContent.trim() : box.value;
                if (label === filterLabel) {
                    box.checked = false;
                }
            });
            // Rimuovi il bottone del filtro attivo
            this.remove();

            // Triggera il cambiamento per aggiornare i filtri
            filterSubmitButton.click();
        });
    });
}

function resetAll() {
    // Deseleziona tutti i checkbox
    filterCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
    });

    // Mostra tutti gli elementi
    showFamilyCards();

    if (window.innerWidth >= 992) {
        showSeparatorBlocks();
    }

    if (window.innerWidth < 992) {
        // Nascondi il reset filtri su mobile
        removeFiltersMobile.classList.remove('active');

        if (document.querySelectorAll('.mobile-active-filters-count').length > 0) {
            document.querySelector('.mobile-active-filters-count').remove();
        }

    } else {
        // Resetta i filtri attivi su desktop
        resetDesktopElements();
    }

    // Chiudi il pannello dei filtri dopo l'applicazione
    toggleFiltersButton.classList.remove('active');
    filtersContainer.classList.remove('open');

    // Resetta MixItUp
    mixer.show();
}

function getSelectedFilters() {

    filterArray = [];

    // Raccogli i filtri selezionati
    filtersGroups.forEach(group => {
        const groupName = group.getAttribute('data-filter-group');
        const checkedFilters = group.querySelectorAll('input[type="checkbox"]:checked');

        if (checkedFilters.length > 0) {
            let groupFilters = [];
            checkedFilters.forEach(checkbox => {
                groupFilters.push(checkbox.value);
            });
            filterArray.push({
                filterGroup: groupName,
                filters: groupFilters
            });
        }
    });

    return filterArray;
}

function filter() {
    // Raccogli i filtri selezionati
    const selectedFilters = getSelectedFilters();

    // Debug: mostra i filtri raccolti
    console.log('Filtri selezionati:', selectedFilters);

    // Controlla se almeno un filtro è selezionato
    if (selectedFilters.length === 0) {
        console.log('Nessun filtro selezionato, mostra tutti gli elementi.');

        // Mostra family-card
        showFamilyCards();

        if (window.innerWidth >= 992) {
            showSeparatorBlocks();
        }

        // Reset di MixItUp per mostrare tutti gli elementi
        mixer.show();

        if (window.innerWidth < 992) {
            // Chiudi il pannello dei filtri su mobile
            removeFiltersMobile.classList.remove('active');

            if (document.querySelectorAll('.mobile-active-filters-count').length > 0) {
                document.querySelector('.mobile-active-filters-count').remove();
            }

        } else {
            // Resetta i filtri attivi su desktop
            resetDesktopElements();
        }

        // Chiudi il pannello dei filtri dopo l'applicazione
        toggleFiltersButton.classList.remove('active');
        filtersContainer.classList.remove('open');

        return;
    }

    console.log('Applicazione dei filtri selezionati.');

    // Nascondi family-card quando si applicano i filtri
    hideFamilyCards();

    if (window.innerWidth >= 992) {
        hideSeparatorBlocks();
    }

    // Reset di MixItUp prima di applicare nuovi filtri
    mixer.show();

    // Applica i filtri raccolti
    selectedFilters.forEach(group => {
        mixer.setFilterGroupSelectors(group.filterGroup, group.filters);
    });

    mixer.parseFilterGroups();

    if (window.innerWidth < 992) {
        // Count checked filters and show count on mobile button
        var count = 0;
        selectedFilters.forEach(group => {
            count += group.filters.length;
        });

        updateMobileActiveFiltersCount();

        // Mostra il pulsante di rimozione filtri su mobile
        removeFiltersMobile.classList.add('active');
    } else {

        let activeFiltersList = getActiveFilters();
        createActiveFiltersHTML(activeFiltersList);

        showDesktopElements();
    }


    // Chiudi il pannello dei filtri dopo l'applicazione
    toggleFiltersButton.classList.remove('active');
    filtersContainer.classList.remove('open');
}

function filterByCheckboxes() {
    // Controlla se almeno un filtro è selezionato
    var selectedFilters = getSelectedFilters();

    // Abilita o disabilita il pulsante di invio in base alla selezione
    if (selectedFilters.length === 0) {

        if (window.innerWidth < 992) {
            updateMobileActiveFiltersCount();
        } else {
            resetDesktopElements();
        }

    } else {
        if (window.innerWidth < 992) {
            updateMobileActiveFiltersCount();
        } else {
            showDesktopElements();
        }
    }
}



export function initCategoryPage() {

    if (!document.querySelector('.category-title')) {
        return;
    }

    initMixer();

    if (document.querySelectorAll('.category-swiper').length > 0) {
        initializeSwiper('.category-swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
                enabled: true,
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    // Inizializza Swiper per la galleria di immagini della famiglia
    const familyGalleries = document.querySelectorAll('.family-gallery');
    if (familyGalleries.length > 0) {
        familyGalleries.forEach(gallery => {
            initializeSwiper(gallery, {
                slidesPerView: 1,
                spaceBetween: 1,
                loop: true,
                pagination: {
                    enabled: true,
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        });
    }

    if (removeAllFiltersButton.length != 0) {
        // Aggiungi evento per rimuovere tutti i filtri
        removeAllFiltersButton.forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                resetAll();
            });
        });
    }

    if (removeFiltersMobile) {
        removeFiltersMobile.addEventListener('click', function (e) {
            e.preventDefault();
            resetAll();
        });
    }


    if (filterSubmitButton) {
        // Aggiungi evento per il toggle del pannello filtri
        toggleFiltersButton.addEventListener('click', function (e) {
            e.preventDefault();

            this.classList.toggle('active');
            filtersContainer.classList.toggle('open');
        });
    }

    if (filterSubmitButton) {
        filterSubmitButton.addEventListener('click', (e) => {
            e.preventDefault();
            filter();
        });
    }

    if (filterCheckboxes.length > 0) {
        filterCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', filterByCheckboxes);
        });
    }

    if (closeFiltersButton) {
        closeFiltersButton.addEventListener('click', function (e) {
            e.preventDefault();

            // Chiudi il pannello dei filtri su mobile
            filtersContainer.classList.remove('open');
        });
    }

    // On resize window, remove mobile count if desktop, show if mobile
    // On resize window, hide active filters on desktop, show on mobile
    window.addEventListener('resize', () => {
        // se mobile nascondi i filtri attivi e mostra il conteggio, se desktop mostra i filtri attivi e nascondi il conteggio
        if (window.innerWidth < 992) {
            // Nascondi filtri attivi
            hideDesktopElements();

            updateMobileActiveFiltersCount();

        } else {

            // Rimuovi conteggio filtri attivi
            if (document.querySelectorAll('.mobile-active-filters-count').length > 0) {
                document.querySelector('.mobile-active-filters-count').remove();
            }

            // Controlla se almeno un filtro è selezionato
            var countActiveFilters = getActiveFiltersCount();

            if (countActiveFilters > 0) {
                showDesktopElements();

                let activeFiltersList = getActiveFilters();
                createActiveFiltersHTML(activeFiltersList);
            } else {
                hideDesktopElements();
                activeFiltersDesktop.innerHTML = '';
            }
        }
    });

}
